// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3BiZB","content":"ManualTimeModal_content__16Ki-"};